import React, { useState, useEffect } from "react";
import axios from "axios";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import { API_URL } from "../../utils/Url";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const UpdatePlan = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    discount: "",
    durationDays: "",
    duration: "",
    features: "",
  });

  const token = sessionStorage.getItem("token");

  // GET PLAN
  const getPlan = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/admin/get/plan/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const plan = data;

      setFormData({
        name: plan.name || "",
        price: plan.price || "",
        discount: plan.discount || "",
        durationDays: plan.durationDays || "",
        duration: plan.duration || "",
        features: plan.features?.join(", ") || "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPlan();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // UPDATE PLAN
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = {
        ...formData,
        features: formData.features ? formData.features.split(",") : [],
      };

      await axios.put(`${API_URL}/api/admin/update/plan/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Plan updated successfully");

      navigate("/get/plans");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating plan");
    }
  };

  return (
    <>
      <Header />
      <Sidebar />

      <div className="main-content mt-5">
        <div className="card shadow">
          <div
            className="card-header align-items-center mb-3 p-2 rounded"
            style={{ backgroundColor: "#fa8ab8" }}
          >
            <h4>Edit Subscription Plan</h4>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Plan Name</label>

                <select
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                >
                  <option value="">Select Plan</option>
                  <option value="Silver Plan">Silver Plan</option>
                  <option value="Gold Plan">Gold Plan</option>
                  <option value="Platinum Plan">Platinum Plan</option>
                  <option value="Till Marriage">Till Marriage</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Price</label>

                <input
                  type="number"
                  className="form-control"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Discount</label>

                <input
                  type="number"
                  className="form-control"
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Duration</label>

                <select
                  className="form-control"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                >
                  <option value="">Select Duration</option>
                  <option value="3 Months">3 Months</option>
                  <option value="6 Months">6 Months</option>
                  <option value="12 Months">12 Months</option>
                  <option value="Till Marriage">Till Marriage</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Duration Days</label>

                <input
                  type="number"
                  className="form-control"
                  name="durationDays"
                  value={formData.durationDays}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Features (comma separated)</label>

                <input
                  type="text"
                  className="form-control"
                  name="features"
                  value={formData.features}
                  onChange={handleChange}
                  placeholder="chat, call, view contact"
                />
              </div>

              <button className="btn btn-success">Update Plan</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePlan;
